import React, { Component, Fragment } from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Radio as ReactRadio } from "common-components/FormContent";
import { RadioButton } from "@vds/radio-buttons"
// import { Input as ReactInput, Label } from "@vzrf/react-forms";    // changes
import { Input } from "@vds/inputs";
import { compose } from "redux";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { downloadAmountChanged, customDateRangeChanged, getPreviousDate } from "../DownloadAndDelete/actions";
import { setA11yContent } from "../../MainContent/NavigationHelper/actions";
import { media, isMobile } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
// import { replaceHashValues } from "utils/replaceHashValues";
import { checkAMLob } from "utils/checkAMLob";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Header from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import { createUpdateProfile, createTimeFrame } from "./actions/commonFormerCustomerAPI";
import Alert from "common-components/Alert";
import Warning from "../../../../../src/assets/svgs/Warning.svg";
import SuccessInputImg from "../../../../../src/assets/svgs/SuccessInputImg.svg";
import { TitleLockup } from "@vds/type-lockups";

class FormerDownloadTimeFrame extends Component {
  state = {
    invalidDates: false,
    startDate: moment(this.props.startDate).format('MM/DD/YYYY'),
    endDate:moment(this.props.endDate).format('MM/DD/YYYY'),
    startError: '',
    endError: '',
    error:''
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Download amount", this.props.pageContent.sc_pagetitle);
    }
  }

  componentDidUpdate(prevProps) {
    
    if (this.props.endDate !== prevProps.endDate || this.props.startDate !== prevProps.startDate) {

        if (this.checkDateDifference() < 30) {
          
          this.props.customDateRangeChanged(moment(getPreviousDate(this.props.endDate)), "startDate");

          if(moment(this.props.endDate) <= moment(new Date()).subtract(5,"years") || moment(this.props.startDate) <= moment(new Date()).subtract(5,"years")){
            this.setState({
              startDate: moment(getPreviousDate(this.props.endDate)).format('MM/DD/YYYY'),
              startError: 'Maximum 5 years',
              invalidDates: false,
              error: ''
            })

            } else{

              this.setState({
                startDate: moment(getPreviousDate(this.props.endDate)).format('MM/DD/YYYY'),
                startError: '',
                invalidDates: false
              })

            }

        }

      
    }
  }

  checkDateDifference = () => {
    const startDate = moment(this.props.startDate);
    const endDate = moment(this.props.endDate);
    const diff = endDate.diff(startDate, "days");
    return diff;
  };

  handleClick = () => {
    const { location, uuid } = this.props

    var startDate;
    var endDate
    if(!this.state.startError && !this.state.endError && !this.state.invalidDates){
      if (this.props.downloadAmount === "Custom") {
        startDate = moment(this.props.startDate).format('YYYY-MM-DD');
        endDate = moment(this.props.endDate).format('YYYY-MM-DD');

      } else {
        startDate = moment().subtract(this.props.downloadAmount, 'days').format('YYYY-MM-DD')
        endDate = moment().format('YYYY-MM-DD')

      }

      var datas = {
        emailId: location.state.data.emailId,
        firstName: location.state.data.fname,
        lastName: location.state.data.lname,
        startDate: startDate,
        endDate: endDate,
        action: location.state.data.currentIntent,
        flow: "timeFrameSelection",
        uuid: uuid,
        serviceType: location.state.data.serviceType,
        formerId: this.props.formerId,
        accountId: this.props.accountInfo

      }
      this.props.createUpdateProfile(datas).then(() => {
        if (!this.props.error) {
          var timeFrameData = {
            caseId: this.props.caseId,
            email: location.state.data.emailId,
            startDate: startDate,
            endDate: endDate,
            intent: location.state.data && location.state.data.currentIntent === "download" ? "Download" : null,
            serviceType: location.state && location.state.data.serviceType ? location.state.data.serviceType : null
          }
          this.props.createTimeFrame(timeFrameData).then(() => {
            if (!this.props.error) {
              this.props.history.replace({
                pathname: "file-format",
                state: { data: location.state.data ? location.state.data : "" }
              });
            }
          })

        }
      })
    }

  };


  handleDownloadAmountChanged = (e) => {
    const selectedOptionItem = this.props.pageContent.genericList[0].list.filter(item => item.jsonKey === e.target.value);
    if (selectedOptionItem && selectedOptionItem.length > 0) {
      const label = selectedOptionItem[0].jsonValue ? selectedOptionItem[0].jsonValue.replace("(recommended)", "") : "";
      this.props.downloadAmountChanged(e, label);
    }
  }
  handleAcctCreationDate=() =>{
    let acctCreationDate = window.reactGlobals.acctCreationDate;

    if (checkAMLob() === "agent") {
      if (checkNestedObject(this.props, "location", "state")) {
        const customerHistory = this.props.location.state.customerHistory;
        if (customerHistory) {
          acctCreationDate = customerHistory.acctCreationDate;
        }
      }
    }

    // if(new Date(moment(acctCreationDate)) < new Date(moment(new Date()).subtract(5,"years"))) {
       
    //   acctCreationDate =  new Date(moment(new Date()).subtract(5,"years").format());
    // }

    return acctCreationDate;
  }
  handleStartDateChange =(e) =>{
    this.setState({
      startDate: e.target.value
    })
    const isValidDate = moment(e.target.value,'MM/DD/YYYY',true).isValid();
    
    if(isValidDate){
      this.props.customDateRangeChanged(new Date(moment(e.target.value)),'startDate');
      const inputDate = e.target.value;

      const isEffectiveDate = this.handleAcctCreationDate() && moment(this.handleAcctCreationDate()) > moment(new Date()).subtract(5,'years') ? moment(inputDate,'MM/DD/YYYY').isBefore(this.handleAcctCreationDate()) : moment(inputDate).isBefore(moment(getPreviousDate(new Date(),1)).subtract(5,"years"));
      const effectiveDate = this.handleAcctCreationDate() ? moment(this.handleAcctCreationDate()) : moment(inputDate);

      if(isEffectiveDate) {

        if(new Date(moment(inputDate)) < new Date(moment(new Date()).subtract(5,'years'))){
          this.setState({
            startDate: moment(e.target.value).format('MM/DD/YYYY'),
            invalidDates: false,
            startError: 'Maximum 5 years',
            error: ''
          });   
        } else {
            if(moment(inputDate) < moment(effectiveDate)){
              this.props.customDateRangeChanged(new Date(moment(effectiveDate)),'startDate');
              this.setState({
                startDate: moment(effectiveDate).format('MM/DD/YYYY'),
                invalidDates: false,
                startError: '',
                error: 'We have updated to your service start date'
              }); 
            }else {
              this.props.customDateRangeChanged(new Date(moment(inputDate)),'startDate');
              this.setState({
                startDate: moment(inputDate).format('MM/DD/YYYY'),
                invalidDates: false,
                startError: '',
                error: ''
              }) 
            }   
      
        }
     } else{
        
            this.setState({
              startDate: moment(inputDate).format('MM/DD/YYYY'),
              invalidDates: false,
              startError: '',
              error: ''
            });

        }

      } else{
        e.target.value ?
      this.setState({
        invalidDates: false,
        startError: 'Invalid date format',
        error: ''
      }) 
      :
      this.setState({
        invalidDates: true,
        startError: '',
        error: ''
      })
      }
}
  handleEndDateChange =(e) =>{
    this.setState({
      endDate: e.target.value
    })
    const isValidDate = moment(e.target.value,'MM/DD/YYYY',true).isValid();

    if(isValidDate){

      if(new Date(moment(e.target.value)) > new Date()){  
        this.props.customDateRangeChanged(new Date(),'endDate');
        this.setState({
          endDate: moment(new Date()).format('MM/DD/YYYY'),
          invalidDates: false,
          endError: '',
          error: ''
        })

      } else if(new Date(moment(e.target.value)) < moment(getPreviousDate(new Date(),1)).subtract(5,"years")){
              this.props.customDateRangeChanged(new Date(moment(e.target.value).subtract(29,'days')),'startDate')
              this.props.customDateRangeChanged(new Date(moment(e.target.value)),'endDate');
              this.setState({
                endDate:  moment(e.target.value).format('MM/DD/YYYY'),
                invalidDates: false,
                endError: 'Maximum 5 years',
                startError: 'Maximum 5 years',
                error: ''

              })

          }  else if(this.handleAcctCreationDate() && new Date(moment(e.target.value)) <= new Date(moment(this.handleAcctCreationDate()).add(30,'days'))){
            this.props.customDateRangeChanged(new Date(moment(this.handleAcctCreationDate()).add(1,'days')),'startDate')
              this.props.customDateRangeChanged(new Date(moment(this.handleAcctCreationDate()).add(30,'days')),'endDate');
              this.setState({
                endDate:  moment(this.handleAcctCreationDate()).add(30,'days').format('MM/DD/YYYY'),
                invalidDates: false,
                startError: '',
                endError: '',
                error: 'We have updated to your service start date'
              })
    
          } 
           else{

                this.props.customDateRangeChanged(new Date(moment(e.target.value)),'endDate');
                this.setState({
                  endDate: moment(e.target.value).format('MM/DD/YYYY'),
                  invalidDates: false,
                  endError: '',
                  error: ''
              })
          }

  } else{

    e.target.value ?
      this.setState({
        invalidDates: false,
        endError: 'Invalid date format',
        error: ''
      }) 
      :
      this.setState({
        invalidDates: true,
        endError: '',
        error: ''
      })

  }

  }


  render() {
    const { pageContent, loading, location } = this.props;
    const { cpraFlagEnabled } = window.reactGlobals || {};
    if (!pageContent) {
      if (location.state.data.serviceType === "guest") {
        return <Redirect to="/privacy/your-data/guest-landing" />;
      } else if (location.state.data.serviceType === "former") {
        return <Redirect to="/privacy/your-data/former-customer" />;
      }
    }

    if (loading) {
      return <RectangleLoader id="formerLoader" />;
    }

    let customDates = pageContent.genericList[1].list

    return (
      <Fragment>
        <Container>
          <div style={{ maxWidth: "693px" }}>
          <TitleLockup 
              viewport={isMobile ? "mobile": "desktop"}
              surface= 'light'
              textAlignment= 'left'
              data={{                
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children: <P>{convertStringToElements(pageContent.section_description)}</P>                      
                 }
               }}          
             />
            {/* <H1>{convertStringToElements(pageContent.section_title)}</H1>
            <P>{convertStringToElements(pageContent.section_description)}</P> */}
          </div>
          <fieldset style={{ margin: "10px 0" }}>
            <Legend htmlFor="download_amount" style={{ color: "#747676" }}>
              {pageContent.genericList[0].text}
            </Legend>
            {pageContent.genericList[0].list.map(item => {
              if (item && item.jsonKey.toLowerCase() === "custom" && undefined !== cpraFlagEnabled && "N" === cpraFlagEnabled) {
                return false;
              }
              if (item && item.jsonKey.toLowerCase() === "custom") {
                return (
                  <CustomContainer activeContainer={this.props.downloadAmount.toLowerCase() === "custom"} key={item.jsonKey}>
                    <div style={{ marginLeft: "20px"}}> 
                    <RadioButton
                      name="downloadAmount"
                      value={item.jsonKey}
                      marginLeft= "20px"
                      children={<span style={{marginLeft:"-28px"}}>{item.jsonValue}</span>}
                      ariaLabel={item.jsonValue}
                      data-testId={item.jsonKey}
                      onChange={this.handleDownloadAmountChanged}
                      selected={item.jsonKey === this.props.downloadAmount}
                    />
                     </div>
                    <CalanderWrapper active={this.props.downloadAmount.toLowerCase() === "custom"}>
                    <InputContainer>  
                    
                      <Input                                
                        type= "date"
                        name="date"
                        label= {customDates[0].jsonKey}
                        readOnly={false}
                        required={true}
                        value= {this.state.startDate}
                        ariaLabel={!this.state.startDate ? 'Start date (MM/DD/YYYY)' : customDates[0].jsonKey+' (MM/DD/YYYY)'}
                        // className={this.state.startError || this.state.error ? "icon" : ""}
                        error={this.state.startError || this.state.error ? true : false}
                        errorText={this.state.startError && !this.state.error ? this.state.startError : !this.state.startError && this.state.error ? this.state.error : "" }
                        // errorText={replaceHashValues(pageContent.genericList[0].startTextError, { 
                        //   accountStartdate: moment(acctCreationDate ? acctCreationDate : "10/7/1983").format(
                        //     "MM/DD/YYYY"
                        //   )
                        // })}                                                                                       
                        // label={pageContent.genericList[0].startText}                  
                        // format="MM/DD/YY"                                                          
                        // helperText="Start date"
                        // helperTextPlacement="top"
                        // inactiveDates={[new Date(2022, 2, 25), new Date(2021, 0, 21), new Date(2021, 0, 22)]}    
                        // maxDate={new Date(getPreviousDate(this.props.endDate,1))}     
                        // minDate={
                        //   acctCreationDate ? new Date(moment(acctCreationDate)) : new Date("10/7/1983") 
                        // }                                                                                     
                        onChange={this.handleStartDateChange}
                        // placeholder="MM/DD/YYYY"
                        // selectedDate={new Date(this.props.startDate)}
                      />
                      
                    </InputContainer>
                    <InputContainer>
                    {/* <Label
                            style={{ color: "#000000", fontFamily: "Verizon-NHG-eTX", height: "16px", fontSize: "14px", lineHeight: "16px" }}
                      >
                      {customDates[1].jsonKey}
                      </Label> */}
                      <Input
                        type= "date"
                        name="date" 
                        label={customDates[1].jsonKey}
                        readOnly={false}
                        required={true}
                        value={this.state.endDate}
                        ariaLabel={!this.state.endDate? 'End date (MM/DD/YYYY)' : customDates[1].jsonKey+' (MM/DD/YYYY)'}
                        // placeholder='MM/DD/YYYY'
                        // className={this.state.endError ? "icon" : ""}
                        error={this.state.endError ? true :  false}
                        errorText={this.state.endError ? this.state.endError : ""}
                        // label={pageContent.genericList[0].endText}
                        // format="MM/DD/YY"
                        // helperText="End date"
                        // helperTextPlacement="bottom"
                        // inactiveDates={[new Date(2022, 2, 25), new Date(2021, 0, 21), new Date(2021, 0, 22)]}
                        // maxDate={new Date()}                                                                     
                        // minDate={
                        //   acctCreationDate ? new Date(moment(acctCreationDate).add(30,"days").format()) : new Date("10/7/1983")
                        // }                                                                                                             
                        onChange={this.handleEndDateChange}
                        // selectedDate={new Date(this.props.endDate)}
                      />
                       {/* {(this.state.endError) && (
                            <ErrorMsg role="alert" >
                              {this.state.endError}
                            </ErrorMsg>
                        )} */}
                    </InputContainer>
                    </CalanderWrapper>
                  </CustomContainer>
                );
              }
              return (
                <div style={{margin:"24px 0px", marginLeft: "20px"}}>
                <RadioButton
                  key={item.jsonKey}
                  name="downloadAmount"
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonValue}</span>}
                  ariaLabel={item.jsonValue}
                  margin-left="-15px"
                  value={item.jsonKey}
                  selected={item.jsonKey === this.props.downloadAmount}
                  onChange={this.handleDownloadAmountChanged}                  
                />
                 </div>                  
              );
            })}
          </fieldset>

          <Div>{convertStringToElements(pageContent.genericList[1].text)}</Div>
          <Button
            background={pageContent.buttons[0].type}
            style={{ marginTop: "48px" }}
            // disabled={this.state.invalidDates}
            onClick={this.handleClick}
          >
            {pageContent.buttons[0].text}
          </Button>

          {checkNestedObject(pageContent, "genericList", [0], "customDescription") ? (
            <div style={{ maxWidth: "434px", marginTop: "22px" }}>
              {convertStringToElements(pageContent.genericList[0].customDescription)}
            </div>
          ) : null}
        </Container>
        {this.props.error ? (
          <Alert alertType="error">{convertStringToElements(this.props.error)}</Alert>
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  pageContent: { time_frame: pageContent },
  downloadAmount: { downloadAmount, startDate, endDate },
  caseCreation: { caseId },
  loadingAndErrorState,
  getUuid: { uuid },
  formerCustomer: { formerId, accountInfo },
}) => ({
  pageContent: pageContent,
  downloadAmount,
  startDate,
  endDate,
  caseId,
  uuid,
  formerId,
  accountInfo,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
});

FormerDownloadTimeFrame.propTypes = {
  downloadAmountChanged: PropTypes.func.isRequired,
  pageContent: PropTypes.object.isRequired
};
export default compose(
  connect(
    mapStateToProps,
    { downloadAmountChanged, customDateRangeChanged, setA11yContent, createUpdateProfile, createTimeFrame }
  ),
  FetchPageContent
)(FormerDownloadTimeFrame);

const P = styled.p`
   max-width:596px;
   font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #6F7171;

    ${media.mobile`
    max-width: 100%;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    letter-spacing: 0.5px;
`}
`;
const Div = styled.div`
  max-width: 490px;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  font-family: 'Verizon-NHG-eDS',Helvetica, Arial, sans-serif;
  padding-bottom: 10px;
  ${media.mobile`
  font-size: 16px;
`}
  p {
    padding: 12px 0;
  }
`;

const Radio = styled(ReactRadio)`
  margin: 24px 0;
  z-index: 10;
`;

const Legend = styled.legend`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const CustomContainer = styled.div`
  padding: 6px 26px 24px 14px;
  margin: -6px -14px;

  ${({ activeContainer }) =>
    activeContainer &&
    `
    background-color: #f8f8f8;
  `}
  
  ${media.mobile`
    padding: 6px 14px 24px 14px;
  `}

  > * {
    &:first-child {
      margin: 0 0 20px 0;
    }
  }
`;

const CalanderWrapper = styled.div`

  ${({ active }) =>
    active ?
      (`
      display: flex;
      justify-content: space-between;
    `) :
      (
        !active ? (`
        display: none;
        pointer-events: none;
      `) :
          ``
      )
  }

  ${media.mobile`
    flex-direction: column;
  `}
`;

// const Input = styled(ReactInput)`
//   width: 90%;
//   border: 1px solid #6F7171;
//   border-radius: 4px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;
const InputContainer = styled.div`
  flex: 50%;
  margin-top: 14px;
  box-sizing: border-box;
  padding-right: 20px
  div {
    display: flex;
  }
  .successicon {
    padding-left: 25px;
    background: url(${SuccessInputImg})no-repeat left;
    background-size: 20px;
    background-position: 99%;
    border: 1px solid  #008331;
    border-radius: 4px;
    background-color:#DCF5E6;
  }
  .icon {
    padding-left: 25px;
    background: url(${Warning})no-repeat left;
    background-size: 20px;
    background-position: 99%;
    border: 1px solid  #C44904 !important;
    background-color:#FBE4D7;
    border-radius: 4px;
  }
  ${media.mobile`
    flex: 100%;
  `}
`;
const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  max-width: 464px;
  margin-top: 5px;
  position:absolute;
  color:#C44904;

  ${media.mobile`
    max-width: 100%;  
  `}
`;
const UpdateMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  max-width: 464px;
  margin-top: 5px;
  position:absolute;
  color:black;

  ${media.mobile`
    max-width: 100%;  
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 596px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding-bottom: 12px;
  font-weight: 300;

  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
​
`;